import React from 'react'
import InputMask from 'react-input-mask'

const MaskedPhoneInput = props => (
  <InputMask mask="+7 (999) 999-99-99" maskChar="_" {...props} />
)

export default MaskedPhoneInput
